// Deep merge helper for site content overrides.
// Arrays from `override` replace the base array entirely; objects merge recursively.
export const deepMerge = (base, override) => {
  if (override === undefined || override === null) return base;
  if (Array.isArray(base) || Array.isArray(override)) return override ?? base;
  if (typeof base === "object" && typeof override === "object") {
    const out = { ...base };
    for (const k of Object.keys(override)) {
      out[k] = k in base ? deepMerge(base[k], override[k]) : override[k];
    }
    return out;
  }
  return override;
};

// Immutable set of a value at a nested path (array of keys/indexes).
export const setPath = (obj, path, value) => {
  if (path.length === 0) return value;
  const [head, ...rest] = path;
  const clone = Array.isArray(obj) ? [...obj] : { ...obj };
  clone[head] = setPath(obj?.[head], rest, value);
  return clone;
};

// Sparse diff: returns only the parts of `edited` that differ from `base`.
// Arrays are compared whole (included only if changed). Returns undefined when equal.
export const diffContent = (base, edited) => {
  if (Array.isArray(edited)) {
    return JSON.stringify(base) === JSON.stringify(edited) ? undefined : edited;
  }
  if (edited && typeof edited === "object") {
    const out = {};
    for (const key of Object.keys(edited)) {
      const sub = diffContent(base ? base[key] : undefined, edited[key]);
      if (sub !== undefined) out[key] = sub;
    }
    return Object.keys(out).length ? out : undefined;
  }
  return base === edited ? undefined : edited;
};
